import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success",
  "use": "icon-success-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-success\"><g transform=\"translate(1 1)\"><circle cx=\"7\" cy=\"7\" r=\"7\" /><path stroke=\"#FFF\" d=\"M11 5l-5.032 5L3 7.05\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol